import React from 'react'
import PropTypes from 'prop-types'
import $ from 'jquery'
import '../../utility/csrf'
import GlobalBanner from '../../components/globalBanner'
import AmountWrapper from '../../components/amountWrapper'
import SubHeader from '../../components/subHeader'
import NextButton from '../../components/nextButton'
import OneTouchNextButton from '../../components/landing/OneTouchNextButton';
import CancelAndReturn from '../../components/cancelAndReturn'
import GuestButton from '../../components/guestButton'
import RecurringCheckBox from '../../components/recurring-checkbox'
import UserDetailsBanner from '../../components/onetouch/UserDetailsBanner';

import templateData from '../../utility/getTemplateData'

import appStore from '../../stores/AppStore'
import appActions from '../../actions/AppActions'

import {
	handleLogIn,
	addShake,
	handleTokenReuse,
	validateDonationAmountForUS
} from '../../utility/helper';
import {
	isOneTouchUser,
	isAuthenticatedUser,
	shouldShowUserBanner
} from '../../utility/authUtils';
import * as amountUtils from '../../components/amount/amountUtils';

import { withRouter } from "react-router-dom";
import * as FPT from '../../utility/fpt'
import { localsMessages, isMobileHeaderExp, isOldButtonFactory } from '../../utility/getTemplateData'
import { loadBodyMovin } from '../../utility/lazyLoader';
import _isEmpty from 'lodash/isEmpty';
import ProgramsContainer from '../../components/programs/ProgramsContainer';

const messages = localsMessages('common/amount')
let currentState = templateData.currentState;

class LandingPageComponent extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasLogo: templateData.hasLogo,
			subHeaderLabel: templateData.donationName,
			orgName: templateData.charityName,
			donationId: templateData.donationId,
			guestRedirectUrl: templateData.guestRedirectUrl,
			donateDisabled: false,
			recurringEnabled: templateData.recurringEnabled,
			recurringStatus: templateData.recurringStatus === 'checked',
			recurringHelpText: '',
			recurringLabel: 'Make this a monthly donation',
			rpContinue: false,
			isAuthenticated: isAuthenticatedUser(),
			memberMandatory: templateData.memberMandatory,
			programNames: templateData.donateContext.program_names
		};
	}

	componentDidMount() {
		appActions.updateCurrentPage({ currentPage: 'landing' });
		$('.spinneroverlay').hide();
		
		// Checking for recurring status if coming from guest page
		if (appStore.getDonationRecurring() === 'checked') {
			this.setState({ recurringStatus: true })
		}

		// Pre-load bodyMovin
		if (templateData.recurringEnabled) {
			loadBodyMovin();
		}
	}

	getFPTDATA = () =>{
		return {
			amount: appStore.getDonationAmount(),
			code: appStore.getDonationCode(),
			symbol: appStore.getDonationSymbol()
		}
	}

	validateAmountAndNavigateToGuestPage = () => {
		let donationAmount = appStore.getDonationAmount();

		if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
			this.props.history.push(`/donate/guest?token=${templateData.token}`)
		} else {
			addShake();
		}
	}

	handleGuest = (event) => {
		event.preventDefault();
		appActions.changeRecurringModalStatus({ recurringModalStatus: 'notclosed' });
		let donationAmount = appStore.getDonationAmount();
		let handleGuestObj = this;
		if (!this.validateDonationAmount()) {
			return;
		}

		if (!amountUtils.isAmountGreaterThanZero(donationAmount)) {
			addShake();
			return;
		}

		if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
			setTimeout(() => {
				let isRPChecked = $("#recurringCheckbox").is(':checked');
				if (isRPChecked && !this.state.memberMandatory) {
					appActions.changeRecurring({
						recurring: "checked"
					});
					$('#signupInfo').modal('show');
				} else {
					this.validateAmountAndNavigateToGuestPage();
				}

				$('#signupInfo').one('hidden.bs.modal', (e) => {
					let recurringModalStatus = appStore.getRecurringModalStatus() === 'closed';
					if(recurringModalStatus){
						appActions.changeRecurringModalStatus({ recurringModalStatus: 'notclosed' });
						return;
					}

					let recurringStatus = appStore.getDonationRecurring() === 'checked';
					if(recurringStatus){
						handleGuestObj.setState({ rpContinue: true });
						this.validateAmountAndNavigateToGuestPage();
					}else{
						appActions.changeRecurring({
							recurring: "unchecked"
						});
						$('#recurringCheckbox').prop('checked', false);
						this.validateAmountAndNavigateToGuestPage();
					}
				})
			},10);
			// Tracking click event with data. 'Pay by card with amount'
			FPT.trackLinkClick('donateWithCard')
		}
	}

	handleNext = (event) => {
		event.preventDefault();
		if (!this.validateDonationAmount()) {
			return;
		}

		let donationAmount = appStore.getDonationAmount()
		if (amountUtils.isAmountGreaterThanZero(donationAmount)) {
			FPT.trackLinkClick('donateWithPayPal')
		}

		handleLogIn()
	}

	displayValidationError = () => {
		const errorMessage = amountUtils.getMinimumDonationErrorMessage(messages);
		this.setState({
			showValidationError: true,
			validationErrorMessage: errorMessage
		});
		addShake();
	}

	hideValidationError = () => {
		this.setState({
			showValidationError: false
		})
	}

	validateDonationAmount = () => {
		if (templateData.donationCode === 'USD') {
			if (validateDonationAmountForUS()) {
				this.setState({
					showValidationError: false,
					validationErrorMessage: ''
				});
				return true;
			}
			this.displayValidationError();
			return false;
		} else {
			if (!amountUtils.isAmountGreaterThanZero(appStore.getDonationAmount())) {
				this.setState({
					showValidationError: true,
					validationErrorMessage: messages.error.amount
				});
				addShake();
				return false;
			}
		}
		return true;
	}

	handleAmountFocus = () => {
		if (this.state.showValidationError) {
			this.hideValidationError();
		}
	}

	updateConversionSataus = (status = false) => {
		this.setState({ donateDisabled: status });
	}

	handleRecurringChange = (status = false) => {
		this.setState({ recurringStatus: status });
	}

	renderProgramsDropdown = () => {
		if (isOldButtonFactory() || _isEmpty(this.state.programNames)) {
			return null;
		}

		return <ProgramsContainer
			programNames={this.state.programNames}
		/>
	}

	render() {
		const showUserBanner = shouldShowUserBanner();

		return (
			<div className={`donate_wrapper ${showUserBanner ? 'user-banner' : ''} ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
				<div className="container">
					{
						showUserBanner ?
						<UserDetailsBanner
							userDetails={templateData.userDetails}
						/> :
						null
					}
					{this.state.hasLogo ? <GlobalBanner /> : null}
					<SubHeader
						donationId={this.state.donationId}
						orgName={this.state.orgName}
						label={this.state.subHeaderLabel}
						page="landing"/>
					<AmountWrapper
						conversionStatus={this.updateConversionSataus}
						validateDonationAmount={this.validateDonationAmount}
						showValidationError={this.state.showValidationError}
						hideValidationError={this.hideValidationError}
						validationErrorMessage={this.state.validationErrorMessage}
						onFocus={this.handleAmountFocus}
					/>
					{this.renderProgramsDropdown()}
					{this.state.recurringEnabled && <RecurringCheckBox
														status={this.state.recurringStatus}
														handleChange={this.handleRecurringChange}
														showNote={false}
														hasRecurringHelp={true}
														continue={this.state.rpContinue}
													/>
					}
					{
						this.state.isAuthenticated
						?	<OneTouchNextButton
								disabled={this.state.donateDisabled}
								handleNext={this.handleNext}/>
						: 	<div>
								<NextButton
									disabled={this.state.donateDisabled}
									handleNext={this.handleNext}/>
								<GuestButton
									disabled={this.state.donateDisabled}
									handleGuest={this.handleGuest}/>
							</div>
					}
					<CancelAndReturn />
				</div>
			</div>
		)
	}
}

const LandingPage = withRouter(LandingPageComponent);


class Landing extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			displayLanding: currentState ? false : true
		};
	}

	componentDidMount() {
		if (currentState) {
			this.props.history.push(currentState)
		} else {
			handleTokenReuse();
		}
	}

	render() {
		return (
			<div>
				{this.state.displayLanding ? <LandingPage /> : null}
			</div>
			)
	}
}

export default withRouter(Landing);



// WEBPACK FOOTER //
// ./pages/landing/landing.js